/**
 * Format currency values
 */
export const formatCurrency = (value, decimals = 2) => {
  if (value === null || value === undefined) return '$0.00';
  return new Intl.NumberFormat('en-US', {
    style: 'currency',
    currency: 'USD',
    minimumFractionDigits: decimals,
    maximumFractionDigits: decimals,
  }).format(value);
};

/**
 * Format numbers with commas
 */
export const formatNumber = (value, decimals = 0) => {
  if (value === null || value === undefined) return '0';
  return new Intl.NumberFormat('en-US', {
    minimumFractionDigits: decimals,
    maximumFractionDigits: decimals,
  }).format(value);
};

/**
 * Format percentage
 */
export const formatPercent = (value, decimals = 1) => {
  if (value === null || value === undefined) return '0%';
  return `${formatNumber(value, decimals)}%`;
};

/**
 * Format date for display
 */
export const formatDate = (date) => {
  if (!date) return '';
  const d = new Date(date);
  return d.toLocaleDateString('en-US', {
    year: 'numeric',
    month: 'short',
    day: 'numeric'
  });
};

/**
 * Format date for API (YYYY-MM-DD)
 */
export const formatDateForAPI = (date) => {
  if (!date) return null;
  const d = new Date(date);
  return d.toISOString().split('T')[0];
};

/**
 * Get date range presets
 */
export const getDateRangePresets = () => {
  const today = new Date();

  return {
    'Last 7 Days': {
      from: new Date(today.getTime() - 7 * 24 * 60 * 60 * 1000),
      to: today
    },
    'Last 30 Days': {
      from: new Date(today.getTime() - 30 * 24 * 60 * 60 * 1000),
      to: today
    },
    'Last 90 Days': {
      from: new Date(today.getTime() - 90 * 24 * 60 * 60 * 1000),
      to: today
    },
    'This Year': {
      from: new Date(today.getFullYear(), 0, 1),
      to: today
    },
    'Last Year': {
      from: new Date(today.getFullYear() - 1, 0, 1),
      to: new Date(today.getFullYear() - 1, 11, 31)
    }
  };
};

/**
 * Shorten large numbers (e.g., 1500 -> 1.5K)
 */
export const shortenNumber = (value) => {
  if (value === null || value === undefined) return '0';

  if (value >= 1000000) {
    return `${(value / 1000000).toFixed(1)}M`;
  }
  if (value >= 1000) {
    return `${(value / 1000).toFixed(1)}K`;
  }
  return value.toString();
};

/**
 * Calculate growth percentage
 */
export const calculateGrowth = (current, previous) => {
  if (!previous || previous === 0) return 0;
  return ((current - previous) / previous) * 100;
};
